import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { FaDownload } from 'react-icons/fa';
import BackButton from '../../components/BackButton';

import img1 from '../../images/customer/1.png';
import img2 from '../../images/customer/2.png';
import img3 from '../../images/customer/3.png';
import img4 from '../../images/customer/4.png';
import img5 from '../../images/customer/5.png';
import img6 from '../../images/customer/6.png';
import img7 from '../../images/customer/7.svg';
import img8 from '../../images/customer/8.png';

import preview1 from '../../images/certs/1.png';
import preview2 from '../../images/certs/2.png';
import preview3 from '../../images/certs/3.png';
import preview4 from '../../images/certs/4.png';

import license1 from '../../images/certs/1.pdf';
import license2 from '../../images/certs/2.pdf';
import license3 from '../../images/certs/3.pdf';
import license4 from '../../images/certs/4.pdf';

export default function AboutPage() {
  const { t } = useTranslation('about');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const customerLogos = [img1, img2, img3, img4, img5, img6, img7, img8];
  const customerNames = t('customers', { returnObjects: true });

  const licenseNames = t('licensesList', { returnObjects: true });
  const equipmentList = t('equipmentList', { returnObjects: true });

  const licenses = [
    { name: licenseNames[0], pdf: license1, preview: preview1 },
    { name: licenseNames[1], pdf: license2, preview: preview2 },
    { name: licenseNames[2], pdf: license3, preview: preview3 },
    { name: licenseNames[3], pdf: license4, preview: preview4 },
  ];

  return (
    <section className="relative min-h-screen text-white bg-gradient-to-b from-[#070b15] to-[#0a111f] pt-32 pb-24 overflow-hidden">
      <div className="grid-bg opacity-60" />
      <div className="glow-orb w-[560px] h-[560px] bg-[#0070d2] opacity-20 -top-40 -left-32 [animation:drift-slow_24s_ease-in-out_infinite,glow-pulse_9s_ease-in-out_infinite]" />
      <div className="glow-orb w-[480px] h-[480px] bg-[#00c2ff] opacity-20 top-1/3 right-[-160px] [animation:drift_15s_ease-in-out_infinite_2s,glow-pulse_9s_ease-in-out_infinite_1.5s]" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 animate-fade-in">
        <BackButton label={t('back')} to="/" />

        <div className="max-w-3xl">
          <h1 className="font-display text-4xl sm:text-5xl font-bold text-white">{t('title')}</h1>
          <span className="title-accent is-visible mb-8" />
          <p className="text-white/70 text-lg leading-relaxed">{t('intro')}</p>
        </div>

        {/* Оборудование */}
        <div className="mt-16">
          <h2 className="font-display text-2xl sm:text-3xl font-bold text-white mb-6">{t('equipmentTitle')}</h2>
          <ul className="glass-card rounded-3xl p-8 space-y-4">
            {equipmentList.map((item, i) => (
              <li key={i} className="flex items-start gap-3 text-white/70 leading-relaxed">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" className="flex-none mt-1 text-cyan-300">
                  <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.4" />
                  <path d="M8.5 12.3l2.3 2.3 4.7-5" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </div>

        {/* Заказчики */}
        <div className="mt-16">
          <h2 className="font-display text-2xl sm:text-3xl font-bold text-white mb-8">{t('clientsTitle')}</h2>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-5">
            {customerLogos.map((img, idx) => (
              <div key={idx} className="glass-card rounded-2xl p-6 flex flex-col items-center text-center gap-3">
                <img src={img} alt={customerNames[idx]} className="h-20 sm:h-24 object-contain" />
                <p className="text-sm text-white/60 leading-snug">{customerNames[idx]}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Лицензии */}
        <div className="mt-16">
          <h2 className="font-display text-2xl sm:text-3xl font-bold text-white mb-4">{t('licensesTitle')}</h2>
          <p className="text-white/60 mb-8 max-w-2xl">{t('licensesDescription')}</p>

          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {licenses.map(({ name, pdf, preview }, idx) => (
              <div key={idx} className="glass-card rounded-2xl p-4 text-center flex flex-col">
                <a href={pdf} target="_blank" rel="noopener noreferrer" className="block rounded-xl overflow-hidden mb-3 bg-white">
                  <img src={preview} alt={name} className="w-full h-[220px] object-cover hover:scale-105 transition duration-300" />
                </a>
                <p className="text-white/70 text-sm mb-3 flex-1">{name}</p>
                <a
                  href={pdf}
                  download
                  className="inline-flex items-center justify-center gap-2 text-sm font-display font-semibold text-cyan-300 hover:text-white transition"
                >
                  <FaDownload /> {t('downloadPdf')}
                </a>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
